import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../../../PageHeader/PageHeader';
import AppButton from '../../../../components/AppButton/AppButton';
import AppInput from '../../../../components/AppInput/AppInput';
import { useDispatch, useSelector } from 'react-redux';
import { addKiosParent, updateKiosParent, searchKiosParent } from '../../../../constant/Constant';
import { HitApi } from '../../../../Api/ApiHit';
import { getSelectedUnit } from '../../../../storage/Storage';
import FileuploadComp from '../../../../components/SingleFileUpload/FileuploadComp';
import { setApiErrorJson, setApiJson } from '../../../../redux/Actions/ApiAction';
import toast from 'react-hot-toast';

function AddKiosParent() {
    const [isLoading, setIsLoading] = useState(false);
    const ApiReducer = useSelector((state) => state.ApiReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const editMode = !!id;

    useEffect(() => {
        if (editMode && id) {
            getData();
        } else {
            dispatch(setApiJson({}));
            dispatch(setApiErrorJson({}));
        }

        return () => {
            dispatch(setApiJson({}));
            dispatch(setApiErrorJson({}));
        };
    }, [id, editMode]);

    const getData = () => {
        const json = {
            page: 1,
            limit: 1,
            search: {
                _id: id
            }
        };
        HitApi(json, searchKiosParent).then((res) => {
            if (res?.statusCode === 200) {
                dispatch(setApiJson(res?.data?.docs?.[0]));
            }
        });
    };

    const validateForm = (data) => {
        const errors = {};
        if (!data.name || data.name.trim() === '') {
            errors.name = 'Group name is required';
        }
        return errors;
    };

    const handleSubmit = () => {
        setIsLoading(true);

        const payload = {
            name: ApiReducer?.apiJson?.name,
            parentDesc: ApiReducer?.apiJson?.parentDesc || '',
            img: ApiReducer?.apiJson?.img || '',
            unitIds: [getSelectedUnit()?._id]
        };

        const errors = validateForm(payload);
        dispatch(setApiErrorJson(errors));

        if (Object.keys(errors).length === 0) {
            if (editMode) {
                const updatePayload = {
                    ...payload,
                    _id: id
                };

                HitApi(updatePayload, updateKiosParent).then((res) => {
                    if (res?.statusCode === 200) {
                        toast.success('Kios group updated successfully!');
                        dispatch(setApiJson({}));
                        navigate('/kioskservices');
                    } else {
                        toast.error(res?.message || 'Failed to update kios group');
                    }
                }).catch((error) => {
                    console.error('Update error:', error);
                    toast.error('Error updating kios group. Please try again.');
                }).finally(() => {
                    setIsLoading(false);
                });
            } else {
                HitApi(payload, addKiosParent).then((res) => {
                    if (res?.statusCode === 201 || res?.success) {
                        toast.success('Kios group created successfully!');
                        dispatch(setApiJson({}));
                        navigate('/kioskservices');
                    } else {
                        toast.error(res?.message || 'Failed to create kios group');
                    }
                }).catch((error) => {
                    console.error('Add error:', error);
                    toast.error('Error creating kios group. Please try again.');
                }).finally(() => {
                    setIsLoading(false);
                });
            }
        } else {
            setIsLoading(false);
            toast.error('Please fill all required fields');
        }
    };

    const hasError = (fieldName) => {
        return ApiReducer.apiJsonError && ApiReducer.apiJsonError[fieldName];
    };

    const getErrorMsg = (fieldName) => {
        return ApiReducer.apiJsonError ? ApiReducer.apiJsonError[fieldName] : "";
    };

    return (
        <div className='p-5'>
            <PageHeader
                title={editMode ? 'Update Kios Group' : 'Add New Kios Group'}
                description={editMode ? 'Update kios group information' : 'Create a new kios group'}
            />
            <div className="bg-white p-8 border rounded-xl mb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <AppInput
                        title="Group Name"
                        placeholder="Enter group name"
                        name="name"
                        important={true}
                        error={hasError('name')}
                        errormsg={getErrorMsg('name')}
                        disabled={isLoading}
                        str
                    />

                    <AppInput
                        title="Description"
                        placeholder="Enter description"
                        name="parentDesc"
                        disabled={isLoading}
                        str
                    />
                </div>

                <div className='mb-5'>
                    <FileuploadComp
                        title="Image"
                        name="img"
                        allowed={["img"]}
                        disabled={isLoading}
                    />
                </div>
            </div>

            <div className='flex mt-5 justify-end'>
                <AppButton
                    buttontext={isLoading ? "Processing..." : (editMode ? "Update Group" : "Add Group")}
                    onClick={handleSubmit}
                    disabled={isLoading}
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
}

export default AddKiosParent;
